import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Mail, MessageCircle } from 'lucide-react';
import { useLanguage } from '@/hooks/useLanguage';

export default function Footer() {
  const { t } = useTranslation();
  const { current } = useLanguage();
  const year = new Date().getFullYear();
  const whatsapp = import.meta.env.VITE_WHATSAPP_LINK;

  return (
    <footer className="bg-ink-900 text-sand-50 mt-16 md:mt-24">
      <div className="container-page py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-2">
            <div className="font-display text-2xl text-sand-50 mb-4">
              Destination<span className="italic"> Paradis</span>
            </div>
            <p className="text-sand-50/70 max-w-md">{t('footer.tagline')}</p>
          </div>

          <div>
            <h3 className="text-xs uppercase tracking-[0.12em] text-gold-400 mb-4 font-sans">
              {t('footer.navTitle')}
            </h3>
            <ul className="space-y-2">
              {(['home', 'destinations', 'packages', 'about', 'contact'] as const).map((k) => (
                <li key={k}>
                  <Link
                    to={`/${current}${k === 'home' ? '' : '/' + k}`}
                    className="text-sand-50/80 hover:text-sand-50 transition-colors text-sm"
                  >
                    {t(`nav.${k}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xs uppercase tracking-[0.12em] text-gold-400 mb-4 font-sans">
              {t('footer.contactTitle')}
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="mailto:ferreira.bat@gmail.com"
                  className="flex items-center gap-2 text-sand-50/80 hover:text-sand-50"
                >
                  <Mail size={14} /> ferreira.bat@gmail.com
                </a>
              </li>
              {whatsapp && (
                <li>
                  <a
                    href={whatsapp}
                    target="_blank"
                    rel="noreferrer noopener"
                    className="flex items-center gap-2 text-sand-50/80 hover:text-sand-50"
                  >
                    <MessageCircle size={14} /> WhatsApp
                  </a>
                </li>
              )}
              <li className="text-sand-50/60 mt-4 pt-4 border-t border-sand-50/10 text-xs leading-relaxed">
                JERICANO HOTELARIA E TURISMO LTDA<br />
                CNPJ 67.132.799/0001-40<br />
                R. Vital Veríssimo, s/n — Vila de Jericoacoara<br />
                Jijoca de Jericoacoara/CE, 62.598-000 — Brasil
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-sand-50/10 text-xs text-sand-50/60 space-y-3">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
            <p className="leading-relaxed">
              JERICANO HOTELARIA E TURISMO LTDA · CNPJ 67.132.799/0001-40 · R. Vital Veríssimo, s/n
              — Vila de Jericoacoara, Jijoca de Jericoacoara/CE, 62.598-000
              <span className="mx-2">·</span>
              <a href="mailto:ferreira.bat@gmail.com" className="hover:text-sand-50 transition-colors">
                ferreira.bat@gmail.com
              </a>
            </p>
            <p>{t('footer.copyright', { year })}</p>
          </div>
          <div className="flex gap-4">
            <Link to={`/${current}/privacy`} className="hover:text-sand-50">{t('footer.privacy')}</Link>
            <Link to={`/${current}/terms`} className="hover:text-sand-50">{t('footer.terms')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
